

import React, { useCallback, useRef, useState, ChangeEvent, forwardRef, useImperativeHandle, } from 'react';
//import * as iconv from "iconv-lite";



export class Printer {

    private port: any | null = null;

    async connectSerial() {
      if (!("serial" in navigator)) {
        alert("Web Serial API not supported");
        return;
      }

      try {
        //portRef.current = await navigator.serial.requestPort();
        this.port = await navigator.serial.requestPort();
        await this.port.open({ baudRate: 115200 });
    
        console.log("Connected to serial device");
      } catch (err) {
        console.error("Serial error:", err);
      }
    }
    
    async SendImage(img : string) {
    
        try {
                // If no port connected then try so
                if ( !this.port){
                    await this.connectSerial();
                }

                const canvas = await loadImageToCanvas(img);
                const mono = canvasToMono(canvas);
                const escpos = buildEscPosImage(canvas.width, canvas.height, mono);
                const encoder = new TextEncoder();

                //const port = printer?.getPort();

                const writer = this.port.writable.getWriter();
                await writer.write(escpos);
                let text =    encoder.encode(    "\n\n\n\n");
                await writer.write(text);

                await writer.releaseLock();
            } catch (err) {
                console.error("Serial error:", err);
            }
        }

    getPort() {
        return this.port;
    }
}

async function loadImageToCanvas(src: string): Promise<HTMLCanvasElement> {
  const img = new Image();
  img.src = src;
  await img.decode();

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d")!;

  // Resize to printer width (important!)
  const maxWidth = 384; // common for 58mm printers
  const scale = maxWidth / img.width;

  canvas.width = maxWidth;
  canvas.height = img.height * scale;

  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  return canvas;
}

function canvasToMono(canvas: HTMLCanvasElement): Uint8Array {
  const ctx = canvas.getContext("2d")!;
  const { width, height } = canvas;

  const imageData = ctx.getImageData(0, 0, width, height).data;

  const bytesPerRow = Math.ceil(width / 8);
  const output = new Uint8Array(bytesPerRow * height);

  // 4x4 Bayer matrix (values 0–15)
  const bayer4 = [
    [0,  8,  2, 10],
    [12, 4, 14, 6],
    [3, 11, 1,  9],
    [15, 7, 13, 5],
  ];

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const i = (y * width + x) * 4;

      const r = imageData[i];
      const g = imageData[i + 1];
      const b = imageData[i + 2];

      // grayscale
      const gray = 0.3 * r + 0.59 * g + 0.11 * b;

      // normalize Bayer threshold to 0–255
      const threshold = (bayer4[y % 4][x % 4] + 0.5) * (255 / 16);

      const bit = gray < threshold ? 1 : 0;

      if (bit) {
        const byteIndex = y * bytesPerRow + (x >> 3);
        output[byteIndex] |= (0x80 >> (x % 8));
      }
    }
  }

  return output;
}

function buildEscPosImage(width: number, height: number, data: Uint8Array) {
  const bytesPerRow = Math.ceil(width / 8);

  const xL = bytesPerRow & 0xff;
  const xH = (bytesPerRow >> 8) & 0xff;
  const yL = height & 0xff;
  const yH = (height >> 8) & 0xff;

  const header = new Uint8Array([
    0x1D, 0x76, 0x30, 0x00, // GS v 0
    xL, xH,
    yL, yH
  ]);

  const result = new Uint8Array(header.length + data.length);
  result.set(header, 0);
  result.set(data, header.length);

  return result;
}
